import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";

import Header from "../components/ContainerHeader";
import SuppliersInviteForm from "../components/suppliersInvite/SuppliersInviteForm";

import { getUser } from "../actions/userActions";
import {TouchPageHeader} from "../AtollonTheme/ReactElements";
import {Card, CardText} from "react-md";

const SuppliersInvite = ({ history, user }) => {
  return (
    <div className="flex-col">
      <TouchPageHeader title="Pozvat dodavatele" history={history} />
      <Card className="margin-bottom">
            <CardText>
                  <SuppliersInviteForm
                    initialValues={{
                      sender: user ? user.identifier : "",
                      subject: "Prosím připojte se k seznamu našich dodavatelů",
                      text: "Zdravím,\n\n" +
                        "rádi bychom, pokud byste se připojili k seznamu našich dodavatelů na Atollon.com.\n\n" +
                        "Atollon nám umožňuje třídit veškeré požadavky, které zasíláme svým dodavatelům, na jednom místě. " +
                        "Také nám pomáhá udržet si jasný přehled o stavu každého jednotlivého požadavku.\n\n" +
                        "Budeme rádi, pokud se připojíte k našim dodavatelům. Pokud doposud nemáte účet Atollon.com, " +
                        "nezabere Vám to více než 5 minut si ho zařídit zdarma a společně ušetříme mnoho času v budoucnosti.\n\n" +
                        "Předem Vám děkuji.\n\n" +
                        (user && user.name ? user.name : "")
                    }}
                    history={history}
                    user={user}
                  />
            </CardText>
      </Card>
    </div>
  );
};

export default compose(
  connect(({ app: { user } }) => ({ user }), { getUser }),
  lifecycle({
    async componentWillMount() {
      const { getUser } = this.props;
      await getUser();
    }
  })
)(SuppliersInvite);



// WEBPACK FOOTER //
// ./src/pages/SuppliersInvite.js